import React from "react"
import Landing from "../components/landing/landing"
import { Tracker } from "../../tracking/tracker"
import { AppOpenEvent } from "../../tracking/events/appOpenEvent"
import { getTrackingPageName } from "../../tracking/trackingConstants"
import { NavigationProvider } from "../navigation/navigationProvider"

function App() {
  const tracker = new Tracker();
  tracker.configure();

  if (sessionStorage.getItem("isAppLoaded") === null) {
    sessionStorage.setItem("isAppLoaded", true);
    const currentPath = window.location.pathname;
    tracker.trackEvent(new AppOpenEvent(getTrackingPageName(currentPath)));
  }

	// const observer = new PerformanceObserver((list) => {
	// 	const entries = list.getEntries();
	// 	const lastEntry = entries[entries.length - 1];
	// 	console.log("LCP:", lastEntry);
	// 	console.log(lastEntry);
	//   });
	//   observer.observe({ type: "largest-contentful-paint", buffered: true });

	// Not tracking app load right now as it triggers on refreshes as well
	if (sessionStorage.getItem("isAppLoaded") === null) {
		sessionStorage.setItem("isAppLoaded", true)
		const currentPath = window.location.pathname;
		tracker.trackEvent(new AppOpenEvent(getTrackingPageName(currentPath)));
	}



	const observer = new PerformanceObserver((list) => {
		const entries = list.getEntries();
		const lastEntry = entries[entries.length - 1];
		// console.log("LCP:", lastEntry);
		// console.log(lastEntry);
	  });
	  observer.observe({ type: "largest-contentful-paint", buffered: true });

	return (
		<NavigationProvider>
			<Landing />
		</NavigationProvider>
	)
}

export default App;
